import './styles.scss';
import React from 'react';
import {RouteComponentProps} from "react-router-dom";
import {useQuery} from "react-query";
import ContractApi from "../../api/Contract/Contract.api";
import DefaultLoader from "../../components/common/DefaultLoader/DefaultLoader";
import ContractDetails from "../../components/specific/Contracts.details/Contracts.details.component";

interface Props extends RouteComponentProps<{ contractId: string }> {

}

function ContractContainer({ match }:Props){

    const {contractId} = match.params;
    const {isLoading, data} = useQuery([`singleContract-${match.params.contractId}`, contractId], ContractApi.get)

    if (isLoading || !data) {
        return (
            <div className='default-loader-full'>
                <DefaultLoader text="Loading contract..."/>
            </div>
        )
    }

    return (
        <div className='contract-container'>
            <ContractDetails contract={data}/>
        </div>
    )
}

export default ContractContainer;